import { i18nHelper } from '@tweddle-se-team/common/helpers'
import apiWrapper from './apiWrapper'
import { getBrowserLanguage } from '../languages'

const { getLocale, setLocale, localesTypes } = i18nHelper

/**
 * Returns the translations for the given locale.
 * Defaults to 'en'.
 * @param {*} locale
 * @returns
 */
export const getTranslations = () => apiWrapper.get('localizations')

export const initLocalizations = async () => {
  const response = await getTranslations()
  const dict = {}
  response.forEach(localization => {
    dict[localization.code] = localization.translations
  })
  return dict
}

export const initLocale = () => {
  const locale = getLocale()
  if (locale) {
    return locale
  }
  const browserLanguage = getBrowserLanguage()
  if (browserLanguage) {
    setLocale(browserLanguage)
    setLocale(browserLanguage, localesTypes.system)
    return getLocale()
  }
}
